import * as React from "react";
import { IReportingPeriodItem } from "../../../model/report/ReportingPeriodItem";
import { Typography, Button, DatePicker, InputNumber } from "antd";
import SelectInput from "../app/SelectInput";
import { SubmitReasons, DateFormats } from "../../../common/Constants";
import moment from "moment";

const Report3ParamsBox = ({
  currentReportingPeriod,
  reportingPeriodList,
  onChangeReportingPeriod,
  getPDFReport,
  translate,
  onPeriodFromChange,
  onPeriodToChange,
  onMinChange,
  onMaxChange,
  onSubmitReasonChange,
  periodFrom,
  periodTo,
  min,
  max,
  submitReason,
  loading
}: {
  currentReportingPeriod?: IReportingPeriodItem;
  reportingPeriodList: IReportingPeriodItem[];
  onChangeReportingPeriod(reportingPeriodId: number): void;
  getPDFReport: any;
  translate: any;
  onPeriodFromChange(periodFrom?: Date): void;
  onPeriodToChange(periodTo?: Date): void;
  onMinChange(min?: number): void;
  onMaxChange(max?: number): void;
  onSubmitReasonChange(submitReasonChange?: string): void;
  periodFrom?: Date;
  periodTo?: Date;
  min?: number;
  max?: number;
  submitReason?: string;
  loading?: boolean;
}) => {
  const isSubmitButtonDisabled = () => {
    if (periodFrom && periodTo && min != null && max != null) {
      return false;
    }
    return true;
  };

  return (
    <div className={"report-sidebar"}>
      <div className={"report-param-title "}>
        <Typography.Title style={{ fontSize: 14 }}>
          {translate("report3.reporting_period")}
        </Typography.Title>
        <SelectInput
          value={currentReportingPeriod?.id.toString()}
          placeholder={translate("report3.choose_reporting_period")}
          selectOptions={reportingPeriodList}
          selectOptionKey={"id"}
          selectOptionValue={"name"}
          style={{ width: "100%" }}
          onChange={(e) => onChangeReportingPeriod(parseInt(e, 10))}
          defaultActiveFirstOption={false}
          showSearch={true}
          notFoundContent={translate("search.no_data")}
        />
        <Typography.Title style={{ fontSize: 14, marginTop: 10 }}>
          {translate("report3.period")}
        </Typography.Title>
        <DatePicker
          style={{ marginBottom: "1em" }}
          placeholder={translate("report3.period_from")}
          value={periodFrom ? moment(periodFrom) : undefined}
          onChange={(date, dateString) => {
            date && onPeriodFromChange(date.toDate());
          }}
          locale={{ dateFormat: DateFormats.DATE }}
          showToday={false}
        ></DatePicker>
        <DatePicker
          placeholder={translate("report3.period_to")}
          value={periodTo ? moment(periodTo) : undefined}
          onChange={(date, dateString) => {
            date && onPeriodToChange(date.toDate());
          }}
          locale={{ dateFormat: DateFormats.DATE }}
          showToday={false}
        ></DatePicker>
        <Typography.Title style={{ fontSize: 14, marginTop: 10 }}>
          {translate("report3.number_of_submited_reports")}
        </Typography.Title>
        <InputNumber
          style={{ marginBottom: "1em" }}
          placeholder={translate("report3.min")}
          value={min}
          onChange={(value) => onMinChange(value)}
        ></InputNumber>
        <InputNumber
          placeholder={translate("report3.max")}
          value={max}
          onChange={(value) => onMaxChange(value)}
        ></InputNumber>

        <Typography.Title style={{ fontSize: 14, marginTop: 10 }}>
          {translate("report3.submit_reason")}
        </Typography.Title>
        <SelectInput
          value={submitReason}
          placeholder={translate("report3.choose_submit_reason")}
          selectOptions={SubmitReasons}
          selectOptionKey={"id"}
          selectOptionValue={"id"}
          style={{ width: "100%" }}
          onChange={(value) => onSubmitReasonChange(value)}
          defaultActiveFirstOption={false}
          showSearch={true}
          notFoundContent={translate("search.no_data")}
          allowClear={true}
        />
      </div>
      <Button
        type="primary"
        onClick={getPDFReport}
        loading={loading}
        disabled={isSubmitButtonDisabled()}
        className={"report-btn"}
      >
        {translate("reports.show")}
      </Button>
    </div>
  );
};
export default Report3ParamsBox;
